import React from "react";
import SysErrorCodeDetails from "../component/SysErrorCodeDetails";

const SysErrorCodeDetailsContainer = ({ pageId }) => (<SysErrorCodeDetails pageId={ pageId } />)

export default SysErrorCodeDetailsContainer;
